import React from 'react';
import MinimapComponent from '../../../shared/components/Minimap';
import Styled from './styles';

class Minimap extends MinimapComponent {
  render() {
    const { zoomIsMinimum } = this.state;
    const { isFullscreen } = this.props;
    const { isPeriodical } = window.Widget.metaController.meta;

    return (
      <Styled.Container
        isFullscreen={isFullscreen}
        isHidden={zoomIsMinimum}
        isPeriodical={isPeriodical}
        onMouseMove={this.handleMouseMoveOnContainer}
      >
        <Styled.Minimap id="minimap" />
        <Styled.CurrentPosition ref={this.getPositionNode} />
      </Styled.Container>
    );
  }
}

export default Minimap;
